import React, { useState, useMemo, useEffect } from "react";
import "./DashboardGrid.css";

export default function DashboardGrid({
  columns = [],
  data = [],
  idField = "IDAGENDAMENTO",
  onSelectionChange,
}) {
  const [filterText, setFilterText] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);

  const filteredData = useMemo(() => {
    if (!filterText) return data;

    const value = filterText.toLowerCase();

    return data.filter((row) =>
      columns.some((col) => {
        const cell = row[col.field];
        return (
          cell !== null &&
          cell !== undefined &&
          String(cell).toLowerCase().includes(value)
        );
      })
    );
  }, [filterText, data, columns]);

  const isSelected = (row) =>
    selectedItems.some((item) => item[idField] === row[idField]);

  const toggleSelect = (row) => {
    setSelectedItems((prev = []) => {
    const exists = prev.some((item) => item[idField] === row[idField]);

    if (exists) {
      return prev.filter((item) => item[idField] !== row[idField]);
    }

    return [...prev, row];
  });
};


  const allSelected =
    filteredData.length > 0 &&
    filteredData.every((row) =>
      selectedItems.some((item) => item[idField] === row[idField])
    );

  const someSelected =
    filteredData.some((row) =>
      selectedItems.some((item) => item[idField] === row[idField])
    ) && !allSelected;

  const toggleSelectAll = () => {
    if (allSelected) {

      setSelectedItems((prev) =>
        prev.filter(
          (item) =>
            !filteredData.some((row) => row[idField] === item[idField])
        )
      );
    } else {

      setSelectedItems((prev) => {
        const map = new Map(prev.map((i) => [i[idField], i]));
        filteredData.forEach((row) => {
          map.set(row[idField], row);
        });
        return Array.from(map.values());
      });
    }
  };

  useEffect(() => {
    onSelectionChange && onSelectionChange(selectedItems);
  }, [selectedItems, onSelectionChange]);

  return (
    <div className="DashboardGrid-container">
      <div className="DashboardGrid-filter">
        <input
          type="text"
          placeholder="Filtrar resultados..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
      </div>

      <table className="DashboardGrid-table">
        <thead>
          <tr>
            <th className="DashboardGrid-checkbox">
              <input
                type="checkbox"
                checked={allSelected}
                ref={(el) => {
                  if (el) el.indeterminate = someSelected;
                }}
                onChange={toggleSelectAll}
              />
            </th>
            {columns.map((col, index) => (
              <th key={index}>{col.header}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {filteredData.length === 0 ? (
            <tr>
              <td colSpan={columns.length + 1} className="DashboardGrid-empty">
                Nenhum registro encontrado.
              </td>
            </tr>
          ) : (
            filteredData.map((row) => (
              <tr
                key={row[idField]}
                className={`DashboardGrid-row ${
                  isSelected(row) ? "selected" : ""
                }`}
                onClick={() => toggleSelect(row)}
              >
                <td
                  className="DashboardGrid-checkbox"
                  onClick={(e) => e.stopPropagation()}
                >
                  <input
                    type="checkbox"
                    checked={isSelected(row)}
                    onChange={() => toggleSelect(row)} //Esta selcionando tudo e não somente a linha
                  />
                </td>

                {columns.map((col, colIndex) => (
                  <td key={colIndex}>
                    {col.formatter
                      ? col.formatter(row[col.field], row)
                      : row[col.field] ?? "-"}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
